<template>
  <v-container>
    <h1 class="font-weight-regular" style="color:#1f245b">Add Device</h1>
    <v-divider></v-divider>
    <v-row dense class="mt-2">
      <v-col>
        <v-card>
              <v-card-title
                class="text-h5 d-flex justify-center my-3"
              >Scan QR</v-card-title>

              <v-card-subtitle class="text-center">
                <qrcode-stream :key="_uid" :track="this.paintOutline" @init="logErrors" />
                <br>
                <v-row dense>
                <v-col>
                  <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-text-field
                      v-model="QRID"
                      :rules="IDRules"
                      label="Device ID"
                      type="text"
                      prepend-icon="mdi-numeric"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="station"
                      :rules="nameRules"
                      label="Stasiun"
                      type="text"
                      prepend-icon="mdi-memory"
                      required
                    ></v-text-field>
                    <v-combobox
                      v-model="location"
                      :items="locations"
                      prepend-icon="mdi-map"
                      label="UPTD PSDA"
                      auto-select-first
                      :rules="locationRequired"
                    >
                    </v-combobox>
                    <v-text-field
                      v-model="latitude"
                      :rules="latlngRules"
                      label="Latitude"
                      type="text"
                      prepend-icon="mdi-latitude"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="longitude"
                      :rules="latlngRules"
                      label="Longitude"
                      type="text"
                      prepend-icon="mdi-longitude"
                      required
                    ></v-text-field>
                    <v-btn
                      class="float-right success"
                      rounded
                      @click="AddDevice(QRID,station,location,latitude,longitude)"
                    >
                      Save
                    </v-btn>
                  </v-form> 
                  </v-col>
                </v-row>
              </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  import { db } from '../firebase/db.js'
  // import firebase from "firebase/compat/app"
  // import 'firebase/compat/auth';

  export default {
    name: 'AddDevice',

    data: () => ({
      QRID:null,
      station:null,
      location:null,
      latitude:null,
      longitude:null,
      valid: true,
      locations:['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE'],
      searchLocation:null,
      IDRules: [
        v => !!v || 'ID is Required',
        v => (v && v.length >=8) || 'ID must be at least 8 characters'
      ],
      nameRules: [
        v => !!v || 'This Field is required'
      ], 
      latlngRules: [
        v => !!v || 'This Field is required',
        v => /^-?[0-9]*\.?[0-9]*$/.test(v) || 'Only number is allowed'
      ],
      locationRequired: [
        v => !!v || 'Location is required',
      ],
    }),
    mounted() {
      if (localStorage.getItem("role")=='Petugas') {
        let device = localStorage.getItem('device')
        this.$router.push(`/MapPetugas-id=${device}&device=${localStorage.getItem('jenis')}`)
      }
      // db.collection('location').doc('locations').onSnapshot((docSnapshot)=> {
      //   this.locations=docSnapshot.data().locations
      // })
    },
    methods: {
      paintOutline (detectedCodes, ctx) {
        for (const detectedCode of detectedCodes) {
          const [ firstPoint, ...otherPoints ] = detectedCode.cornerPoints
          this.QRID=detectedCode.rawValue;
          ctx.strokeStyle = "red";

          ctx.beginPath();
          ctx.moveTo(firstPoint.x, firstPoint.y);
          for (const { x, y } of otherPoints) {
            ctx.lineTo(x, y);
          }
          ctx.lineTo(firstPoint.x, firstPoint.y);
          ctx.closePath();
          ctx.stroke();
        }
      },

      logErrors (promise) {
        promise.catch(console.error)
      },

      async AddDevice(QRID,station,location,latitude,longitude) {
        if (this.$refs.form.validate()) {
          let loader = this.$loading.show()
          var deviceRef = db.collection('device').doc(QRID)
          var SettingRef = db.collection('setting').doc(QRID)
          let exists=0;
          await deviceRef.get().then((doc) => {
            if(doc.exists) {
              loader.hide()
              exists=1;
              alert("DEVICE SUDAH TERDAFTAR")
              return
            }
          })
          if (!exists) {
            await SettingRef.update({
              notifA:'10',
              notifC:'92',
              voltLow:'6',
              location:location,
              station: station,
            }).catch(() => {
              alert("ID TIDAK TERDAFTAR")
            })
            await deviceRef.set({
              latitude:latitude,
              longitude:longitude,
              station:station,
              location:location,
              condition:"Tidak Hujan",
              macAddress: QRID,
              bat: 'Normal',
              password:'12345678',
              time:'0',
            }).then(() => {
              loader.hide()
              this.$router.push('/')
            }).catch(() => {
              alert("ID TIDAK TERDAFTAR")
            })
          }
        }
      }
    },
    watch: {
      // location (val, prev) {
      //   val = val != null ? val : ''
      //   prev = prev != null ? prev : ''
      //   if (val.length === prev.length) return
      //   if (val!== '') {
      //     if (this.locations.indexOf(val)===-1) {
      //       this.locations.push(val)
      //       var locRef = db.collection('location')
      //       console.log(this.locations)
      //       locRef.doc('locations').set({
      //         locations:this.locations
      //       })
      //     }    
      //   }
      // },
    }
  }
</script>
